import React__default, { forwardRef, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import clsx from 'clsx';

const ESC_KEY = 27;
const MOUSE_DOWN_EVENT = 'mousedown';
const KEY_DOWN_EVENT = 'keydown';
const ModalTitle = ({ title, classes = {}, roundCloseButton = false, handleClose }) => {
    const titleClassName = clsx('c-modal__title', classes.title);
    const closeIconClassName = clsx('c-modal__close', classes.closeIcon, roundCloseButton && 'u--round');
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { className: titleClassName }, title),
        React__default.createElement("div", { className: closeIconClassName, "data-testid": 'qa-close-button', onClick: handleClose })));
};
const ModalActions = ({ children, className, ...divProps }) => {
    return (React__default.createElement("div", { className: clsx('c-modal__buttons', className), ...divProps }, children));
};
const ModalContent = ({ children, className, ...divProps }) => (React__default.createElement("div", { className: clsx('c-modal__content', className), ...divProps }, children));
const Modal = forwardRef(({ id, isOpen, handleClose, designSize = 'small', ignoreOutsideClicks = false, children, className, container = document.getElementById('modal') || document.getElementsByTagName('body')[0], ...divProps }, ref) => {
    const wrapperRef = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                handleClose();
            }
        };
        const handleClickESC = (event) => {
            if (event.keyCode === ESC_KEY) {
                handleClose();
            }
        };
        if (isOpen) {
            if (!ignoreOutsideClicks) {
                document.addEventListener(MOUSE_DOWN_EVENT, handleClickOutside);
            }
            document.addEventListener(KEY_DOWN_EVENT, handleClickESC);
        }
        return () => {
            if (!ignoreOutsideClicks) {
                document.removeEventListener(MOUSE_DOWN_EVENT, handleClickOutside);
            }
            document.removeEventListener(KEY_DOWN_EVENT, handleClickESC);
        };
    }, [isOpen, handleClose, ignoreOutsideClicks]);
    return isOpen
        ? createPortal(React__default.createElement("div", { ref: ref, key: id, className: clsx('c-modal', className) },
            React__default.createElement("div", { ref: wrapperRef, className: clsx('c-modal__window', `c-modal__window--${designSize}`, className), ...divProps }, children)), container)
        : null;
});

export { Modal, ModalActions, ModalContent, ModalTitle, Modal as default };
//# sourceMappingURL=index.js.map
